/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import { IReCaptchaModel, FORM_ID, RECAPTCHA_FIELD_NAME } from './Model';
import App from '../../App';

const app = App.get();

const CAPTCHA_CALLBACK = 'onRecaptchaData';

class ReCaptcha extends React.Component<IReCaptchaModel> {
    componentWillMount() {
        (window as any)[CAPTCHA_CALLBACK] = this.onRecaptchaData.bind(this);
    }

    onRecaptchaData(response: string) {
        app.updateFormField(FORM_ID, RECAPTCHA_FIELD_NAME, response);
    }

    render() {
        let error;
        if (this.props.errorMessage) {
            error = <div className="error">{this.props.errorMessage}</div>;
        }
        let script;
        let div;
        if (this.props.config) {
            script = <script src={'https://' + this.props.config.challengeUrl} async defer />;
            div = (
                <div
                    className="g-recaptcha"
                    data-sitekey={this.props.config.siteKey}
                    data-theme={this.props.config.theme}
                    data-type={this.props.config.type}
                    data-size={this.props.config.size}
                    data-callback={CAPTCHA_CALLBACK}
                />
            );
        }

        return (
            <div className="captcha">
                {error}
                {script}
                {div}
            </div>
        );
    }
}

export { ReCaptcha as default };
